module.exports = __webpack_public_path__ + "static/media/rootstechByFS.dfab34f1.svg";